import React from "react";
import AppRoute from "./routes/AppRoutes";
import { CustomProvider } from "rsuite";

export default function App() {
  return (
    <CustomProvider>
      <AppRoute />
    </CustomProvider>
  );
}
